import React from 'react';
import SectionCollapse from '../../../../../section/SectionCollapse';
import TextValue from '../../../../../text/TextValue';
import QuestionsInformation from './QuestionsInformation';
import YearLevelsInformation from './YearLevelsInformation';
import RolesInformation from './RolesInformation';

const TemplateInfo = ({ action, detail = {}, isAssessment = false }) => {
  return (
    <>
      <TextValue title='Template' classNameValue='capitalize' value={detail?.title} />
      <div className='py-2' />
      {isAssessment ? (
        <SectionCollapse title={`Year Levels (#${detail?.yearLevels?.length})`}>
          <YearLevelsInformation action={action} detail={detail} />
        </SectionCollapse>
      ) : (
        <SectionCollapse title={`Roles (#${detail?.roles?.length})`}>
          <RolesInformation action={action} detail={detail} />
        </SectionCollapse>
      )}

      <SectionCollapse title={`Questions (#${detail?.questions?.length})`}>
        <QuestionsInformation action={action} detail={detail} />
      </SectionCollapse>
    </>
  );
};

export default TemplateInfo;
